// src/router.js
import Vue from 'vue';
import Router from 'vue-router';
import Layout from '@/views/layout/Index.vue'; 
import Home from '@/views/home/Home.vue';
import ProductDetail from '@/components/ProductDetail.vue';
//chat Ai


Vue.use(Router);

const routes = [
    {
        path: '/',
        component: Layout,
        children:[
            {
                path:'',
                name:'home',
                component:Home
            },
           {
            path: '/product/:id', // 动态路由，匹配商品 ID
            name: 'product-detail',
            component: ProductDetail,
            props: true, // 将路由参数作为属性传递给组件
           },
         
        ]
    },
   
];

const router = new Router({
    mode: 'history', // 使用历史模式，URL中不会带有#
    routes,
});

export default router;
